export default {
    mapper: {
        relations: {
            belongsToMany: {
                line: {
                    foreignKey: 'id',
                    localField: 'lines',
                },
            },
        },
    },
};
